const getVal = require('lodash/get');

/* eslint-disable no-restricted-syntax -- need */
/* eslint-disable complexity -- pre-existing */
const conditionCases = (type, conditonObject, objectOfFunctions) => {
  let val = conditonObject && conditonObject.propertyKey
    ? getVal(objectOfFunctions, conditonObject.propertyKey) : null;
  let mapResponseValue = null;
  switch (type) {
    case 'greaterThan':
      if (val && val > conditonObject.mapCondition.valueToCompare) {
        mapResponseValue = conditonObject.mapCondition.truthyAction;
      } else {
        mapResponseValue = conditonObject.mapCondition.falsyAction;
      }
      break;
    case 'equalTo':
      if (val && val === conditonObject.mapCondition.valueToCompare) {
        mapResponseValue = conditonObject.mapCondition.truthyAction;
      } else {
        mapResponseValue = conditonObject.mapCondition.falsyAction;
      }
      break;
    case 'nestedEqualTo':
      if (val && val === conditonObject.mapCondition.valueToCompare) {
        mapResponseValue = conditonObject.mapCondition.truthyAction;
      } else if (typeof conditonObject.mapCondition.falsyAction === 'object') {
        let fActionObj = conditonObject.mapCondition.falsyAction;
        if (fActionObj.propertyKey) {
          val = getVal(objectOfFunctions, fActionObj.propertyKey);
        }
        let fAction = true;
        while (fAction) {
          if (val === fActionObj.valueToCompare) {
            mapResponseValue = fActionObj.truthyAction;
            fAction = false;
          } else if (typeof fActionObj.falsyAction === 'object') {
            fActionObj = fActionObj.falsyAction;
            if (fActionObj.propertyKey) {
              val = getVal(objectOfFunctions, fActionObj.propertyKey);
            }
          } else {
            mapResponseValue = fActionObj.falsyAction;
            fAction = false;
          }
        }
      } else {
        mapResponseValue = conditonObject.mapCondition.falsyAction;
      }
      break;
    case 'valuePresent':
      if (val && val !== '') {
        mapResponseValue = conditonObject.mapCondition.truthyAction;
      } else {
        mapResponseValue = conditonObject.mapCondition.falsyAction;
      }
      break;
    case 'valuesPresentInAnArray':
      {
        const mapCondition = conditonObject.mapCondition.type || 'OR';
        const valuesToCheck = conditonObject.mapCondition.values;
        if (val && val.length > 0) {
          for (const value of valuesToCheck) {
            if (val.indexOf(value) !== -1) {
              mapResponseValue = conditonObject.mapCondition.truthyAction;
              if (mapCondition === 'OR') break;
            } else {
              mapResponseValue = conditonObject.mapCondition.falsyAction;
              if (mapCondition === 'AND') break;
            }
          }
        } else {
          mapResponseValue = conditonObject.mapCondition.falsyAction;
        }
      }
      break;
    case 'multipleValueMappings':
      // fieldIndicator won't change change in case val is undefined
      if (val || val === '') {
        if (conditonObject.mapCondition.values.indexOf(val) !== -1) {
          mapResponseValue = conditonObject.mapCondition.truthyAction;
        } else {
          mapResponseValue = conditonObject.mapCondition.falsyAction;
        }
      } else if (val === undefined && conditonObject.mapCondition.defaultAction) {
        mapResponseValue = conditonObject.mapCondition.defaultAction;
      }
      break;
    case 'multipleKeyPresentMapping':
      {
        let valToCompare = false;
        const keyArr = conditonObject.mapCondition.valueToCompare;
        const mapCondition = conditonObject.mapCondition.type;
        const functionObj = { ...objectOfFunctions };
        for (const element of keyArr) {
          const keys = Object.keys(functionObj[conditonObject.mapCondition.propertyToLookFrom]);
          if (keys.includes(element)) {
            valToCompare = true;
            if (mapCondition === 'OR') break;
          } else if (mapCondition === 'AND') {
            valToCompare = false;
            break;
          }
        }
        if (valToCompare) {
          mapResponseValue = conditonObject.mapCondition.truthyAction;
        } else {
          mapResponseValue = conditonObject.mapCondition.falsyAction;
        }
      }
      break;
    case 'multiKeyValueMappings':
      {
        let entityPreScreeningPassValue = '';
        // default OR operations
        const mappings = conditonObject.multiKeyValueMappings;
        const keysArray = Object.keys(mappings);
        for (const element of keysArray) {
          const propertyVal = getVal(objectOfFunctions, element);
          if (conditonObject.mapCondition === 'AND') {
            if (propertyVal && mappings[element].indexOf(propertyVal) !== -1) {
              mapResponseValue = conditonObject.truthyAction;
            } else if (!propertyVal && (mappings[element].indexOf('') !== -1 || mappings[element].indexOf('undefined') !== -1)) {
              mapResponseValue = conditonObject.truthyAction;
            } else {
              mapResponseValue = conditonObject.falsyAction;
              break;
            }
          } else if (conditonObject.mapCondition === 'NOR') {
            if (element === 'formSubmissionPayload.dynamicClicDetails.LegalEntityDetails') {
              entityPreScreeningPassValue = propertyVal;
              mapResponseValue = conditonObject.falsyAction;
            } else if (!entityPreScreeningPassValue && element !== 'formSubmissionPayload.dynamicClicDetails.LegalEntityDetails' && propertyVal && mappings[element].indexOf(propertyVal) !== -1) {
              mapResponseValue = conditonObject.truthyAction;
            } else {
              mapResponseValue = conditonObject.falsyAction;
            }
          } else {
            if (mappings[element].indexOf(propertyVal) !== -1) {
              mapResponseValue = conditonObject.truthyAction;
              break;
            }
            mapResponseValue = conditonObject.falsyAction;
          }
        }
      }
      break;
    case 'compareValues': {
      const { valuesToCompare } = conditonObject.mapCondition;
      let allEqual = false;
      if (valuesToCompare && Array.isArray(valuesToCompare)) {
        const firstItemValue = getVal(objectOfFunctions, valuesToCompare[0]);
        allEqual = valuesToCompare.every((item) => {
          const currentItemValue = getVal(objectOfFunctions, item);
          return currentItemValue === firstItemValue;
        });
      }
      mapResponseValue = allEqual
        ? conditonObject.mapCondition.truthyAction
        : conditonObject.mapCondition.falsyAction;
      break;
    }
    default: mapResponseValue = null;
  }
  return mapResponseValue;
};
/* eslint-enable no-restricted-syntax -- need */

/* eslint-disable no-restricted-syntax -- need */
const dyanmicPageEvaluationMethod = (currentPage, formContainer, objectOfFunctions) => {
  let mapResponseValue = null;
  if (formContainer.operations.pageEvalution) {
    const pageDetailsArr = formContainer.operations.pageEvalution;
    for (const pageDetail of pageDetailsArr) {
      if (pageDetail.page > currentPage) {
        if (pageDetail.displayValidation) {
          const pageDisplayValidations = pageDetail.displayValidation;
          const validationResults = [];
          for (const validation of pageDisplayValidations) {
            mapResponseValue = conditionCases(
              validation.mapCondition.condition, validation, objectOfFunctions
            );
            validationResults.push(mapResponseValue);
          }
          if ((pageDetail.condition === 'AND' && validationResults.includes(false))
            || (pageDetail.condition === 'OR' && validationResults.every(false))) {
            mapResponseValue = false;
          }
          if (mapResponseValue) {
            break;
          }
        } else {
          mapResponseValue = pageDetail.page;
          break;
        }
      }
    }
  }
  return mapResponseValue;
};
/* eslint-enable no-restricted-syntax -- need */
/* eslint-enable complexity -- pre-existing */

/* eslint-disable max-params -- need */
const extractMapResponseValueByKey = (
  jsonObject, propertykey, objectOfFunctions, formContainer
) => {
  let mapResponseValue = null;
  if (jsonObject[propertykey]) {
    if (jsonObject[propertykey].multiKeyValueMappings) {
      mapResponseValue = conditionCases(
        'multiKeyValueMappings', jsonObject[propertykey], objectOfFunctions
      );
    } else if (jsonObject[propertykey].evaluateDynamicNextPage) {
      const { currentPage } = jsonObject[propertykey].evaluateDynamicNextPage;
      mapResponseValue = dyanmicPageEvaluationMethod(
        currentPage, formContainer, objectOfFunctions
      );
    } else {
      const val = getVal(objectOfFunctions, jsonObject[propertykey].propertyKey);
      if (jsonObject[propertykey].mapCondition) {
        mapResponseValue = conditionCases(
          jsonObject[propertykey].mapCondition.condition,
          jsonObject[propertykey],
          objectOfFunctions
        );
      } else {
        mapResponseValue = jsonObject[propertykey].mapResponse[val];
      }
    }
  }
  return mapResponseValue;
};
/* eslint-enable max-params -- need */

export { conditionCases, dyanmicPageEvaluationMethod, extractMapResponseValueByKey };
